import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_upload_outlined = _resolveComponent("upload-outlined");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_upload = _resolveComponent("a-upload");
  const _component_vertical_align_bottom_outlined = _resolveComponent("vertical-align-bottom-outlined");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, null, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "基本信息"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24,
              style: {
                "padding-top": "30px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "客户代码",
                  rules: [{
                    required: true,
                    message: '请输入客户代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fCustNumber,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.fCustNumber = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fFileName",
                  label: "文件名称",
                  rules: [{
                    required: true,
                    message: '请上传价格表!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fFileName,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model.fFileName = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 24,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "价格表"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_upload, {
                    name: "file",
                    action: $setup.DMConfig.uploadurl,
                    maxCount: "1",
                    showUploadList: false,
                    headers: $setup.DMConfig.headers,
                    "before-upload": $setup.OnBeforeUpload,
                    onChange: $setup.OnUploadChange
                  }, {
                    default: _withCtx(() => [_createVNode(_component_a_button, null, {
                      default: _withCtx(() => [_createVNode(_component_upload_outlined), _createTextVNode(" 上传价格表(.Pdf) ")]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["action", "headers", "before-upload", "onChange"]), _createVNode(_component_a_button, {
                    style: {
                      "margin-left": "5px"
                    },
                    onClick: $setup.OnDownload
                  }, {
                    default: _withCtx(() => [_createVNode(_component_vertical_align_bottom_outlined), _createTextVNode(" 下载 ")]),
                    _: 1
                  }, 8, ["onClick"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "onOk"]);
}